import { NodeType } from 'shared/types/ingestion'
import { CustomNodeProps } from 'json-edit-react'
import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { PotentiallyHtml } from '../../../PotentiallyHtml'
import { isNode } from 'shared/utils'

export const noteNodeDef = {
  condition: ({ value }: { value: unknown }) => {
    if (!isNode(value)) return false
    return value.type === NodeType.Note
  },
  element: NoteNode,
}

function NoteNode({ data }: CustomNodeProps) {
  const [showValue, setShowValue] = useState(false)
  if (!isNode(data)) return null
  return (
    <Box>
      <Box>{`Title: ${data.title}`}</Box>
      <Box>
        <Button
          disabled={!data.body?.value}
          onClick={() => setShowValue(!showValue)}
        >
          Value
        </Button>
      </Box>
      {showValue && (
        <Box>
          <PotentiallyHtml s={data.body?.value} />
        </Box>
      )}
    </Box>
  )
}
